module.exports = __webpack_public_path__ + "static/media/portfolio2.0187c454.jpg";